import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Divider
} from '@mui/material';
import {
  Layers as SectionsIcon,
  ChevronRight as ChevronRightIcon,
  Language as LanguageIcon,
  Description as DescriptionIcon
} from '@mui/icons-material';
import useAuth from '../hooks/useAuth';
import { PageTitleContainer } from '../components/common';

const Settings = () => {
  const { user } = useAuth();

  // Check if user is admin or has permission
  const isAdmin = user?.role === 'admin';

  if (isAdmin) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#475969' }}>
          You don't have permission to access this page.
        </Typography>
      </Container>
    );
  }

  return (
    <Box sx={{
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      px: 6,
      m: 0,
      pt: 4,
      overflowX: 'hidden',
    }}>
      <PageTitleContainer
        title="Administration"
        sx={{
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          ml: 0,
          mr: 0,
          mb: 2,
          mt: 0,
          py: '16px'
        }}
        titleProps={{
          sx: { fontFamily: "'Sofia Pro Bold', 'Sofia Pro', sans-serif", fontWeight: 700 }
        }}
      />
      <Box sx={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', height: 'calc(100vh - 200px)', background: 'white' }}>

        <Card sx={{boxShadow: 'none !important'}}>
          <CardContent sx={{ padding: '0 !important' }}>
            <List sx={{ p: 0 }}>
              <ListItem
                component={Link}
                to="/settings/sections"
                button
                sx={{
                  py: 3,
                  px: 3,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                  },
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                <ListItemIcon sx={{ minWidth: 48 }}>
                  <SectionsIcon sx={{ color: '#485869' }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#475969' }}>
                      Section Management
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ fontSize: '14px', color: '#a2abb3' }}>
                      Manage sections and assign role permissions
                    </Typography>
                  }
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon sx={{ color: '#a2abb3' }} />
                </ListItemSecondaryAction>
              </ListItem>

              <Divider />

              <ListItem
                component={Link}
                to="/settings/translations"
                button
                sx={{
                  pt: 3,
                  px: 3,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                  },
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                <ListItemIcon sx={{ minWidth: 48 }}>
                  <LanguageIcon sx={{ color: '#485869' }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#475969' }}>
                      Translation Management
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ fontSize: '14px', color: '#a2abb3' }}>
                      Manage multilingual translations
                    </Typography>
                  }
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon sx={{ color: '#a2abb3' }} />
                </ListItemSecondaryAction>
              </ListItem>

              <Divider />

              <ListItem
                component={Link}
                to="/settings/org-documents"
                button
                sx={{
                  py: 3,
                  px: 3,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                  },
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                <ListItemIcon sx={{ minWidth: 48 }}>
                  <DescriptionIcon sx={{ color: '#485869' }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#475969' }}>
                      Organization Documents
                    </Typography>
                  }
                  secondary={
                    <Typography sx={{ fontSize: '14px', color: '#a2abb3' }}>
                      Manage Infanion default documents (field validations, guidelines)
                    </Typography>
                  }
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon sx={{ color: '#a2abb3' }} />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Settings;